import { render, staticRenderFns } from "./ActivityMain.vue?vue&type=template&id=77b80657"
import script from "./ActivityMain.vue?vue&type=script&lang=js"
export * from "./ActivityMain.vue?vue&type=script&lang=js"
import style0 from "./ActivityMain.vue?vue&type=style&index=0&id=77b80657&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports